'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAttributesSeries = undefined;
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
var getAttributesSeries = exports.getAttributesSeries = function getAttributesSeries(observations) {
  return R.pipe(R.values, R.reduce(function (acc, _ref) {
    var attributes = _ref.attributes;
    var res = acc.res;
    var rejected = acc.rejected;
    R.forEachObjIndexed(function (attribute) {
      if (!R.isNil(attribute.serieKey)) {
        if (R.isNil(attribute.value)) {
          res = R.dissocPath([attribute.serieKey, attribute.id], res);
          rejected = R.assocPath([attribute.serieKey, attribute.id], true, rejected);
        }
        if (R.path([attribute.serieKey, attribute.id], rejected)) {
          return;
        }
        var valueInRes = R.path([attribute.serieKey, attribute.id, 'value', 'id'], res);
        if (!R.isNil(valueInRes) && valueInRes !== R.path(['value', 'id'], attribute)) {
          res = R.dissocPath([attribute.serieKey, attribute.id], res);
          rejected = R.assocPath([attribute.serieKey, attribute.id], true, rejected);
        } else {
          res = R.assocPath([attribute.serieKey, attribute.id], attribute, res);
        }
      }
    }, attributes);
    return {
      res: res,
      rejected: rejected
    };
  }, {
    res: {},
    rejected: {}
  }), R.prop('res'))(observations);
};